import { Box, Stack, Typography } from '@mui/material';
import OrganisationTableSelect from './OrganisationTableSelect';
import { Organisation } from '../../../@types/organization';
import { useTranslator } from 'translation/useTranslator';

type SelectOrganizationProps = {
  organisations: Organisation[];
};
const SelectOrganization = ({ organisations }: SelectOrganizationProps) => {
  const translator = useTranslator();
  return (
    <>
      <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h4" gutterBottom>
            {translator.selectOrganization()}
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>
            {translator.youAreAssociatedWithMultipleOrganizations()}
          </Typography>
        </Box>
      </Stack>
      <OrganisationTableSelect organisations={organisations} />
    </>
  );
};

export default SelectOrganization;
